export default __webpack_public_path__ + "static/media/pulses.63bb9be1.svg";